import { Injectable } from '@angular/core';
import { BooleanAgFloatingFilterComponent, BooleanAgFloatingFilterParams, BooleanCellRendererParams, CovanceGridColumn, yesNoRenderer } from '../../../covance-ag-grid';
import { comparators } from '../../../core';
import { GridColumns } from '../../../shared/grid-columns';
import { UserPermissions } from '../../../user-permissions/user-permissions';
import { HideMenuAgRendererComponent } from './hide-menu-ag-renderer.component';
import { UserPermissionsStorage } from '../../../user-permissions/user-permissions-storage';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ColDef } from 'ag-grid-community';
import { HiddenEQUeryAgRendererComponent } from '../../../covance-ag-grid/renderers/hidden-e-query-ag-renderer.component';
import {EQueryAdminSummary} from '../models/e-query-admin-summary';
import { SubjectTitleRenderer } from '../../../renderer/subject-title-renderer';

@Injectable()
export class AdminEQueryHideColumns {
    public readonly columns$: Observable<CovanceGridColumn[]>;
    private readonly eQueryId: CovanceGridColumn = {
        headerName: 'eQueryId',
        field: 'eQueryId',
        width: 90,
        comparator: (a, b) => comparators.numberComparator(a, b)
    };

    private readonly accessionNumber: CovanceGridColumn = {
        headerName: 'Accession',
        field: 'accessionNumber',
        width: 120,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly subject: CovanceGridColumn = {
        headerName: 'Subject',
        field: 'subjectId',
        width: 90,
        valueGetter: (params: { data: EQueryAdminSummary }) => {
            if (!params.data) {
                return null;
            }
    
            const subjectTitle = params.data.subjectNumber ?  SubjectTitleRenderer.renderTitle({
                data: {
                    subjectNumber: params.data.subjectNumber,
                    initials: params.data.initials,
                    screeningNumber: null,
                    zcSubjectId: params.data.subjectId
                }
            }) : '';
    
            return subjectTitle;
        },
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };
    
    private readonly protocolName: CovanceGridColumn = {
        headerName: 'Protocol',
        field: 'protocolName',
        width: 90,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    }; 

    private readonly protocolVisitCode: CovanceGridColumn = {
        headerName: 'PVC',
        field: 'protocolVisitCode',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };  

    private readonly hiddenColumn: ColDef = {
        headerName: 'Hidden?',
        field: 'isHidden',
        width: 20,
        getQuickFilterText: () => { return ''; },
        cellRendererFramework: HiddenEQUeryAgRendererComponent,
        filter: 'agSetColumnFilter',
        filterParams: {
            cellRenderer: (params: BooleanCellRendererParams) => yesNoRenderer(params.value)
        },
        floatingFilterComponentFramework: BooleanAgFloatingFilterComponent,
        floatingFilterComponentParams: {
            booleanValueRenderer: yesNoRenderer
        } as BooleanAgFloatingFilterParams
    };
    
    private readonly visitName: CovanceGridColumn = {
        headerName: 'Visit',
        field: 'visitName',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly responders: CovanceGridColumn = {
        headerName: 'Responders',
        field: 'responders',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b),
        valueGetter: (params: {data: EQueryAdminSummary}) => {
            if (!params.data) {
                return '';
            }
            return params.data.responders.join(', ');
        }
    };

    constructor( private gridColumns: GridColumns,
                 private permissionsStorage: UserPermissionsStorage) {
        this.columns$ = permissionsStorage.userPermissions.pipe(
            map(userPermissions => this.getEQueriesHideUnhideColumns(userPermissions))
        );
    }

    private getEQueriesHideUnhideColumns(userPermissions: UserPermissions): CovanceGridColumn[] {  
        const editMenuColumn = this.buildEditMenuColumn(userPermissions);
        return [this.eQueryId,
                this.accessionNumber,
                this.subject,
                this.protocolName,
                this.visitName,
                this.protocolVisitCode,
                this.responders,
                this.hiddenColumn,
                editMenuColumn
               ];
        }

    private buildEditMenuColumn(userPermissions: UserPermissions) {
        return this.gridColumns.actionsMenuColumn({
            cellRendererFramework: HideMenuAgRendererComponent,
            userPermissions: userPermissions
        });
    }
}
